var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-break-settings" }, [
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label" }, [
        _vm._v("Buton Hizalaması"),
      ]),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localAlign,
              expression: "localAlign",
            },
          ],
          staticClass: "setting-select",
          on: {
            change: [
              function ($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function (o) {
                    return o.selected
                  })
                  .map(function (o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.localAlign = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              _vm.updateField,
            ],
          },
        },
        [
          _c("option", { attrs: { value: "left" } }, [_vm._v("Sol")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "center" } }, [_vm._v("Orta")]),
          _vm._v(" "),
          _c("option", { attrs: { value: "right" } }, [_vm._v("Sağ")]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label" }, [
        _vm._v("Devam Butonu Metni"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localNextButtonText,
            expression: "localNextButtonText",
          },
        ],
        ref: "nextButtonTextInput",
        staticClass: "setting-input",
        attrs: { type: "text", placeholder: "Devam" },
        domProps: { value: _vm.localNextButtonText },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localNextButtonText = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label" }, [
        _vm._v("Geri Butonu Metni"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localPreviousButtonText,
            expression: "localPreviousButtonText",
          },
        ],
        ref: "previousButtonTextInput",
        staticClass: "setting-input",
        attrs: { type: "text", placeholder: "Geri" },
        domProps: { value: _vm.localPreviousButtonText },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localPreviousButtonText = $event.target.value
            },
            _vm.updateField,
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label checkbox-label" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localShowPreviousButton,
              expression: "localShowPreviousButton",
            },
          ],
          staticClass: "setting-checkbox",
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.localShowPreviousButton)
              ? _vm._i(_vm.localShowPreviousButton, null) > -1
              : _vm.localShowPreviousButton,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localShowPreviousButton,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localShowPreviousButton = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localShowPreviousButton = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localShowPreviousButton = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v("\n            Geri Butonunu Göster\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label checkbox-label" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localShowNextButton,
              expression: "localShowNextButton",
            },
          ],
          staticClass: "setting-checkbox",
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.localShowNextButton)
              ? _vm._i(_vm.localShowNextButton, null) > -1
              : _vm.localShowNextButton,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localShowNextButton,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localShowNextButton = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localShowNextButton = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localShowNextButton = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v("\n            Devam Butonunu Göster\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label checkbox-label" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.localVisibility,
              expression: "localVisibility",
            },
          ],
          staticClass: "setting-checkbox",
          attrs: { type: "checkbox" },
          domProps: {
            checked: Array.isArray(_vm.localVisibility)
              ? _vm._i(_vm.localVisibility, null) > -1
              : _vm.localVisibility,
          },
          on: {
            change: [
              function ($event) {
                var $$a = _vm.localVisibility,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.localVisibility = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.localVisibility = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.localVisibility = $$c
                }
              },
              _vm.updateField,
            ],
          },
        }),
        _vm._v("\n            Alan Görünür\n        "),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "setting-group" }, [
      _c("label", { staticClass: "setting-label" }, [
        _vm._v("URL Parametresi"),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localSlug,
            expression: "localSlug",
          },
        ],
        ref: "slugInput",
        staticClass: "setting-input",
        attrs: { type: "text", placeholder: "pagebreak" },
        domProps: { value: _vm.localSlug },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.localSlug = $event.target.value
            },
            function ($event) {
              return _vm.setSlug($event.target.value)
            },
          ],
        },
      }),
      _vm._v(" "),
      _c(
        "small",
        {
          staticStyle: {
            "font-size": "0.75rem",
            color: "#6b7280",
            "margin-top": "0.25rem",
            display: "block",
          },
        },
        [_vm._v("URL parametrelerinde kullanılacak benzersiz tanımlayıcı")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }